import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-login-audit',
  templateUrl: './login-audit.component.html',
  styleUrls: ['./login-audit.component.css']
})
export class LoginAuditComponent implements OnInit {
	respObject: any;
	laData: any;

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;

  email="";
  status="";
  offset = this._rest.PER_PAGE_ROW;

  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	/*const data = {}
  	this._rest.getLoginAudit(data).subscribe((res) => {
  		this.respObject = res;
    	if(this.respObject.error==0){
    		this.laData = this.respObject.resp;
    	}
  	});*/
    this.searchLoginAudit(1);
  }

  next() {
    if(this.laData.length > 0) {
      this.offset = this.offset + this.perPageRow;
      this.curPage = this.offset / this.perPageRow;
      this.searchLoginAudit(this.curPage);
    }
  }
  previous() {
    if (this.curPage > 0) {
      this.offset = this.offset - this.perPageRow;
      this.curPage = this.offset / this.perPageRow;
      this.searchLoginAudit(this.curPage);
    }
  }

  searchLoginAudit(curPage){
    this.curPage= curPage;
    const searchData = {
      "status":this.status,
      "email":this.email,
      "page": this.curPage,
      "limit":this.perPageRow
    };
    this.laData = [];
    this._rest.getLoginAudit(searchData).subscribe((res) => {
      this.respObject = res;
      if(this.respObject.error==0){

        this.laData = this.respObject.resp.data;
        this.totalRows = this.respObject.resp.info;
        this.noOfRows=this.respObject.resp.data.length;
        this.pages=[];
        for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
          this.pages.push(i);
        }
      } else {
        this.totalRows = 0;
        this.noOfRows = 0;
        this.pages=[];
        this.laData=[];
      }
      //console.log(JSON.stringify(this.respPeer));
      
    })
  }

}
